<template>
    <div class="main">
        <div class="actions">
             <button @click="$router.push({ name: 'warehouse-details', params: { id: wareHouseId } })" style="border: 0; background: transparent; font-size:14px;text-decoration:none;line-height:30px;color:#98c14b;display:flex">
                <p>
                    <a-icon type="double-left" />
                </p> 
                <p>Go Back</p>
            </button>
           
        </div>
          <h3 style="font-size:28px;line-height:45px">Delivery Products</h3>
        <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;">
            
            <a-button @click="exportDeliveryLines" style="height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;" icon="export">
                Export 
            </a-button>
        </div>
        <div>
            <a-table
                :columns="deliverLinesColumns"
                :data-source="tableDeliveryLinesData"
                :loading="tableLoading"
                :pagination="pagination"
                class="tableStyle"
                >
                    <template slot="action" slot-scope="data">
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item>
                                    <a @click="showWareDetails(data)">View More?</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </template>
            </a-table>
        </div>

    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
// import _ from 'lodash';
import { NotificationMixins } from "@/mixins/NotificationMixins";
import XLSX from "xlsx";

const deliverLinesColumns = [
    {
        title: 'ID',
        // width: 150,
        key: 'id',
        dataIndex: 'id',
    },
    {
        title: 'Product Name',
        // width: 150,
        key: 'productBrandName',
        dataIndex: 'productBrandName',
    },
    {
        title: 'Category',
        // width: 150,
        key: 'productCategoryName',
        dataIndex: 'productCategoryName',
    },
    {
        title: 'Supplier',
        // width: 150,
        key: 'productSupplierName',
        dataIndex: 'productSupplierName',
    },
    {
        title: 'Quantity',
        // width: 150,
        key: 'quantity',
        dataIndex: 'quantity',
    },
    {
        title: 'Batch Number',
        // width: 150,
        key: 'batchNumber',
        dataIndex: 'batchNumber',
    },
    {
        title: 'Expiry Date',
        // width: 150,
        key: 'batchExpiry',
        dataIndex: 'batchExpiry',
    },
    // {
    // title: "Action",
    //     dataIndex: "action",
    //     key: 'action',
    //     scopedSlots: { customRender: "action" },
    // }
]
    export default {
        name: 'DeliveryLines',
        mixins: [NotificationMixins],
        data(){
            return{
                tableDeliveryLinesData:[],
                tableLoading: false,
                deliverLinesColumns,
                pagination: {
                    pageSize:20
                },
                params:{
                    page: -1,
                    perPage:-1,
                    searchBy: {},
                    sortBy: {}
                },
                addSupplierModel:{
                    supplierName: '',
                    supplierAddress: '',
                    supplierPhoneNumber:'',
                    supplierDescription: ''
                },
                deliveryLines: {},
                wareHouseId: '',
                addSupplierVisible: false,
                dateFormat: 'DD/MM/YYYY',
                startDate: moment(),
                endDate: moment(),
                loading: false,
                rules:{
                    notes: [
                        { required: true, message: 'Please this field cannot be empty' , trigger: 'change'},
                    ],
                    name: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    
                    manufacturerName: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    description: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    manufacturerDescription: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    supplierName: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    supplierAddress: [
                        { required: true, message: 'Please enter address' , trigger: 'change'},
                    ],
                    supplierPhoneNumber: [
                        { required: true, message: 'Please enter phone number' , trigger: 'change'},
                    ],
                    supplierDescription: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    categoryName: [
                        { required: true, message: 'Please enter name' , trigger: 'change'},
                    ],
                    categoryDescription: [
                        { required: true, message: 'Please enter description' , trigger: 'change'},
                    ],
                    categoryGroup: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    isRestricted: [
                        { required: true, message: 'Please select your option' , trigger: 'change'},
                    ],
                    categoryCommission: [
                        { required: true, message: 'Please enter commission', trigger: 'change' },
                        {   
                                pattern: new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/),  
                                message: 'Please enter valid number', 
                                trigger: 'change'
                        },
                    ],
                }
            }
        },
        computed:{
            ...mapGetters(['getWareHouseDeliveryLinesInfo','getWareHouseInfo']),
        },
        methods:{
          ...mapActions(['getAllWarehousesData','setWareHouseInfo','updateProductSupplier']),
          onChange(date, dateString) {
                // console.log(date, dateString);
                this.startDate = dateString[0];
                this.endDate = dateString[1];
                // console.log("startDate | ", this.startDate);
                // console.log("endDate | ", this.endDate);
            },
            moment,
           
            showSupplierModal(){
                this.addSupplierVisible = true;
            },
            supplierOnChange(checked){
                this.isSupplierEnabled = checked
            },
            showWareDetails(){
                // this.setWareHouseInfo(data)
                // this.$router.push({
                // name: 'warehouse-details',
                // params: { id: data.id }
                // }).catch(()=>{})

            },
            
            exportDeliveryLines(){
            const dataToExport = [
                [
                    "Delivery ID",
                    "Product Name",
                    "Quantity",
                    "Batch Number",
                    "Batch Expiry"
                ],
            ];
            
            this.delivery.deliveryLines.forEach((v) => {
                dataToExport.push([
                        v.id,
                        v.productBrandName,
                        v.quantity,
                        v.batchNumber,
                        v.batchExpiry
                    ]);
                });
                
                
                let wb = XLSX.utils.book_new();
                let ws = XLSX.utils.aoa_to_sheet(dataToExport);

                /* Add the worksheet to the workbook */
                XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

                /* generate file and send to client */
                XLSX.writeFile(wb, `Warehouse-Delivery-Products-Report-${moment().format('DD-MM-YYYY')}.xlsx`);
                this.exportLoading = false;
                this.showSuccessAlert("Data Successfully Exported")
        },
           
            handleAddSupplierCancel(){
                this.addSupplierVisible = false;
            },
             handleAddSupplierSubmit(){
                this.$refs.addSupplierForm.validate(valid => {
                        if (valid) {
                            this.loading = true;
                            const request = {
                                name:  this.addSupplierModel.supplierName,
                                address: this.addSupplierModel.supplierAddress,
                                metadata:{
                                    phoneNumber: this.addSupplierModel.supplierPhoneNumber,
                                    description: this.addSupplierModel.supplierDescription,
                                },
                                status: 1
                            }
                        
                            
                            this.addProductSupplier(request).then(response => {
                                
                                this.loading = false;
                                if(response.status === 200){
                                    this.getProductsMgtData();
                                    this.showSuccessAlert("Supplier Added Successfully")
                                    this.addSupplierVisible = false;
                                    this.$refs.addSupplierForm.resetFields();
                                }else{
                                    this.showErrorAlert(response.data.messages)
                                }
                            },
                            error =>{
                                this.loading = false
                                this.showErrorAlert(JSON.stringify(error))
                            })                    
                        } else {
                            // console.log('error submit!!');
                            return false;
                        }
                });
            },
              
        async getAllDeliveryLines(){
                this.tableDeliveryLinesData = this.delivery.deliveryLines.map(deliveryLines => ({
                    key: deliveryLines.id,
                    id: deliveryLines.id,
                    productBrandName: deliveryLines.productBrandName,
                    productCategoryName: deliveryLines.productCategoryName ? deliveryLines.productCategoryName : "N/A",
                    productSupplierName: deliveryLines.productSupplierName ? deliveryLines.productSupplierName : "N/A",
                    quantity: deliveryLines.quantity,
                    batchNumber: deliveryLines.batchNumber,
                    batchExpiry: moment(deliveryLines.batchExpiry).format('DD-MM-YYYY'),
                    action: deliveryLines
                }))
        }
           
        },
        created() {
          if(this.getWareHouseDeliveryLinesInfo){
              this.delivery = this.getWareHouseDeliveryLinesInfo
              this.getAllDeliveryLines()
          }
          if(this.getWareHouseInfo){
              this.wareHouseId = this.getWareHouseInfo.id
          }
        }
    }
</script>

<style scoped>

.actions{
    display: flex;
    justify-content: space-between;
}
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.tableStyle >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle >>> .ant-pagination-item-active a {
    color: #fff;
}
.tableStyle >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
a {
  color: #418a49;
}
a:hover{
  color: #418a49;
}
button:hover{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

button{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}
.tableStyle >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.ant-switch-checked {
    background-color: #418a49;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

</style>